import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../context/ProductBuilder/machine';
import { hasCurrentMeasureInsurance } from '../../../../helpers/hasCurrentMeasureInsurance';
import { isInitialState } from '../../../../helpers/isInitialState';
import { hasMeasureInsurance } from '../../../../helpers/measureInsurance';
import { Heading } from '../../../Common/Heading';
import { AccountLoginModal } from '../../AccountLoginModal/AccountLoginModal';
import { SectionContent } from '../SectionContent';
import { Loading } from './Loading';
import { Ready } from './Ready';

export const MeasureInsurance = () => {
  const [state] = useService(productBuilderMachine);
  const { cart, customer } = state.context;
  const customerHasMeasureInsuranceInCart = hasMeasureInsurance(cart);
  const customerHasCurrentMeasureInsurance = hasCurrentMeasureInsurance(
    customer,
  );
  // Allowing user to select measure insurance regardless of whether the cart request has succeeded
  const isReady = ['measureInsurance.ready', 'measureInsurance.failure'].some(
    state.matches,
  );
  const isLoading = state.matches('measureInsurance.loading');

  const [isAccountLoginModal, setIsAccountLoginModal] = React.useState(false);
  const openAccountLoginModal = () => {
    setIsAccountLoginModal(true);
  };

  const closeAccountLoginModal = () => {
    setIsAccountLoginModal(false);
  };
  const showPopup =
    localStorage.getItem('displayAccountPopup') === 'true' && customer === null;
  if (
    (!customerHasMeasureInsuranceInCart &&
      state.matches('measureInsurance.loading') &&
      !isAccountLoginModal) ||
    (!customerHasMeasureInsuranceInCart &&
      isInitialState(state) &&
      !isAccountLoginModal &&
      showPopup)
  ) {
    localStorage.setItem('displayAccountPopup', 'false');
    openAccountLoginModal();
  }

  return (
    <SectionContent>
      <Heading>Measure Insurance</Heading>
      {isLoading && <Loading />}
      {isReady && <Ready />}
      <AccountLoginModal
        // measureInsurancePage={}
        modalIsOpen={isAccountLoginModal}
        openModal={openAccountLoginModal}
        closeModal={closeAccountLoginModal}
      />
    </SectionContent>
  );
};
